export default "../css/22825fb305d2597fce2e2d9cd2d7d17b.ttf";